import { Component, OnInit } from '@angular/core';
import { CommonsService } from 'src/app/services/commons/commons.service';
import { MatDialog} from '@angular/material/dialog';
import {MsgDialog} from "../dialog/message-dialog/message-dialog.component";
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  versione: string = '2.0.0'; // valore di default
  showAssistenza: boolean = false;

  constructor(private router: Router, private commonsService: CommonsService, public dialog: MatDialog) { }

  ngOnInit(): void {
    this.caricaVersione();
    this.mostraLinkAssistenza();
  }

  caricaVersione(): void {
    this.commonsService.getVersione().subscribe({
      next: (response) => {
        this.versione = response.result.descrizione;
      },
      error: (error) => {
        console.error('Errore nel caricamento della versione:', error);
      }
    });
  }

    openMsgDialog(): void {
      const dialogRef = this.dialog.open(MsgDialog, {
        data: ''
      });
      dialogRef.afterClosed().subscribe((result: any) => {
  
      })
    }

    mostraLinkAssistenza(): void {
      this.router.events.subscribe((ev) => {
            if (ev instanceof NavigationEnd) {
              let userInfo: any = sessionStorage.getItem('userInfo');
              if (userInfo) this.showAssistenza = true;
            }
          });
    }
}
